import config from "../config/environment";

const baseURL = config.GO_BACKEND_URL || "";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export async function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window;
}

export async function getPushSubscriptionState() {
  if (!(await isPushSupported())) return null;
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
}

export async function subscribeToPushNotifications() {
  console.log("[push] starting subscription");
  if (!(await isPushSupported())) {
    throw new Error("Push notifications are not supported on this device/browser");
  }
  console.log("[push] push supported");

  const permission = await Notification.requestPermission();
  console.log("[push] permission:", permission);
  if (permission !== "granted") {
    throw new Error(`Notification permission ${permission}`);
  }

  const response = await fetch(`${baseURL}/push-vapid-public-key`);
  console.log("[push] vapid response status:", response.status);
  let { publicKey } = await response.json();
  publicKey = (publicKey || "").toString().trim();
  console.log("[push] vapid public key present:", !!publicKey, "length:", publicKey.length);
  if (!publicKey) {
    throw new Error("No VAPID public key returned by server");
  }

  const registration = await navigator.serviceWorker.ready;
  console.log("[push] service worker ready, scope:", registration.scope);
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });
  console.log("[push] pushManager.subscribe succeeded:", subscription);

  const payload = subscription.toJSON();
  console.log("[push] subscribing on backend, endpoint:", payload.endpoint);
  const res = await fetch(`${baseURL}/push-subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  console.log("[push] backend subscribe status:", res.status);

  if (!res.ok) {
    const text = await res.text();
    console.error("[push] backend subscribe error:", text);
    throw new Error(`Failed to store subscription: ${res.status} ${text}`);
  }

  console.log("[push] subscription stored successfully");
  return subscription;
}

export async function unsubscribeFromPushNotifications() {
  if (!(await isPushSupported())) return;
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    await subscription.unsubscribe();
  }
}
